import { render, staticRenderFns } from "./LiverpoolCity.vue?vue&type=template&id=1c713f19&scoped=true&"
import script from "./LiverpoolCity.vue?vue&type=script&lang=js&"
export * from "./LiverpoolCity.vue?vue&type=script&lang=js&"
import style0 from "./LiverpoolCity.vue?vue&type=style&index=0&id=1c713f19&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c713f19",
  null
  
)

export default component.exports